<template>
  <ul class="advantages container">
    <li v-for="item of advantages" class="advantages__text-wrapper">
      <h3 class="advantages__title" v-html="item.title"></h3>
      <p class="advantages__text" v-html="item.text"></p>
    </li>
  </ul>
</template>

<script>
export default {
  name: "block-advantages",
  data(){
    return {
      advantages: [
        {
          title: '200+',
          text: 'тренажеров',
        },
        {
          title: '2500м<sup>2</sup>',
          text: 'общая площадь клуба',
        },
        {
          title: '20+',
          text: 'видов групповых программ',
        },
      ]
    }
  }
}
</script>

<style lang="scss">
@import '../styles/constants.scss';

.advantages{
  display: flex;
  justify-content: space-around;
  margin-top: 2em;
  margin-bottom: 2em;

  @media (max-width: 840px) {
    font-size: 0.8em;
  }

  @media (max-width: 640px) {
    font-size: 0.7em;
  }

  @media (max-width: 450px) {
    flex-direction: column;
    justify-content: stretch;
  }

  @media (max-width: 350px) {
    font-size: 0.65em;
  }

  &__text-wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 32%;
    font-family: "Bebas Neue", sans-serif;
    padding: 1em;
    box-shadow: 5px 5px 15px hsla(0, 0%, 0%, 0.1);

    @media (max-width: 450px) {
      width: 100%;
      flex-direction: row;
    }
  }

  &__title{
    font-size: 4em;
    color: $primary;
    text-shadow: 1px 2px 2px #000;

    @media (max-width: 450px) {
      width: 50%;
      text-align: center;
      font-size: 3em;
    }

    sup{
      font-size: 0.5em;
      font-weight: bold;
    }
  }

  &__text{
    font-size: 1.5em;
    text-transform: uppercase;
    text-align: center;

    @media (max-width: 450px) {
      text-align: left;
    }
  }
}
</style>